import { useState, useEffect } from "react";
import { parseDateFlexible } from "../utils/utils";
import moment from "moment";

const EMPTY_TIME_SINCE = Object.freeze({
  days: 0,
  hours: 0,
  minutes: 0,
  seconds: 0,
});

const Timer = ({ startTime, type }) => {
  const redTime = 11;
  const calculateTimeSince = startTime => {
    if (typeof startTime !== "string" && typeof startTime !== "number") {
      return EMPTY_TIME_SINCE;
    }

    const now = moment.utc();
    const parsedTime = parseDateFlexible(startTime);
    if (!parsedTime?.isValid()) {
      return EMPTY_TIME_SINCE;
    }

    const time = +parsedTime.utc();
    const difference = +now - +time;

    if (difference > 0) {
      return {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }

    return EMPTY_TIME_SINCE;
  };

  const [timeSince, setTimeSince] = useState(calculateTimeSince(startTime));

  useEffect(() => {
    setTimeSince(calculateTimeSince(startTime));
    const interval = setInterval(() => {
      setTimeSince(calculateTimeSince(startTime));
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, [startTime]);

  let seconds = ("0" + Math.floor(timeSince.seconds)).slice(-2);
  let minutes = ("0" + Math.floor(timeSince.minutes)).slice(-2);
  let hours = ("0" + Math.floor(timeSince.hours)).slice(-2);
  let days = ("0" + Math.floor(timeSince.days)).slice(-3);

  const parsedDate =
    typeof startTime === "string" || typeof startTime === "number"
      ? parseDateFlexible(startTime)
      : null;
  let now = moment();

  if (startTime && parsedDate?.isBefore(now)) {
    return (
      <div
        style={{
          color:
            type === "officer" && (days > 0 || hours > 0 || minutes >= redTime)
              ? "red"
              : "",
        }}
      >
        {days > 0
          ? `${days}:${hours}:${minutes}:${seconds}`
          : `${hours}:${minutes}:${seconds}`}
      </div>
    );
  } else {
    return <div></div>;
  }
};

export default Timer;
